<template>
  <div class="flex w-6/12 px-2 mb-5">
    <div class="mx-auto flex flex-col space-y-2.5">
      <div>
        <div
            @click="onClick"
            class="mx-auto hover:border-red-cardinal transition-colors cursor-pointer w-24 h-24 bg-white border border-gray-suva flex items-center justify-center relative">
          <div
              v-if="isActive"
              class="bg-red-cardinal bg-opacity-20 absolute transition-all w-full h-full"></div>
          <slot name="icon"></slot>
        </div>
      </div>
      <div>
        <div
            class="font-titlinggothicfbnormal select-none text-center text-12px font-medium uppercase">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onClick: {
      type: Function,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>